// @ts-strict-ignore
import React from 'react';

import { useContentSubsite } from 'cms/hooks';
import { Box } from 'components/Box';
import { Breadcrumbs } from 'components/Breadcrumbs';
import { PrintHidden } from 'components/PrintHidden';
import PostSearchInputContainer from 'containers/PostSearchInputContainer';
import { Page } from 'store/main/ducks/contents';
import { colors, gutterWidth, shadows } from 'theme';

type Props = {
  content: Page;
};

export function SearchToolbar({ content }: Props) {
  const subsite = useContentSubsite({ content });

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line prefer-destructuring
  const homePage = subsite.homePage;
  const isHomePage = homePage && homePage.url === content.url;
  const hasBreadcrumbs = !isHomePage;
  const links = [
    {
      title: subsite.publicName,
      to: `/${subsite && homePage.url}`,
      'data-qa-id': 'breadcrumbs-home-link',
    },
  ];

  if (!isHomePage) {
    links.push({
      title: content.title,
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ pathname: string; state: { subsite: Subsit... Remove this comment to see the full error message
      to: {
        pathname: `/${content.url}`,
        state: {
          subsite,
        },
      },
    });
  }

  return (
    <PrintHidden>
      <Box
        data-qa-id="search-toolbar"
        position="relative"
        zIndex={1}
        py={12}
        px={gutterWidth / 2}
        display="flex"
        flexWrap="wrap"
        alignItems="center"
        justifyContent="space-between"
        bg={colors.white}
        borderTop={`1px solid ${colors.platinum}`}
        boxShadow={shadows.toolbar}
      >
        <Box width="50%" flex="0 0 auto" pr={16}>
          {hasBreadcrumbs && <Breadcrumbs links={links} />}
        </Box>
        <Box
          width={586}
          maxWidth="50%"
          justifyContent="flex-end"
          display="flex"
        >
          <PostSearchInputContainer
            homePageUrl={subsite.homePage.url}
            searchPlaceholderText={subsite.searchPlaceholderText}
          />
        </Box>
      </Box>
    </PrintHidden>
  );
}
